import React from 'react';
import { TiBatteryCharge, TiBatteryHigh, TiBatteryMid, TiBatteryLow } from 'react-icons/ti';

export const statusTypeStandardization = (type, flag) => {
  switch (type) {
    case 'o2':
      return (
        <span>
          O<sub>2</sub>(%)
        </span>
      );
    case 'hc':
      return flag === "0" ? <p>CH4(%)</p> : <p>HC(%)</p>;
    case 'co':
      return <span>CO(ppm)</span>;
    case 'co2':
      return (
        <span>
          CO<sub>2</sub>(ppm)
        </span>
      );
    case 'h2s':
      return (
        <span>
          H<sub>2</sub>S(ppm)
        </span>
      );
    case 'ph':
      return <span>pH</span>;
      
    case 'temp':
      return <span>temp</span>;
      
    case 'humi':
      return <span>humi</span>;
      
    case 'heatindex':
      return <span>heatindex</span>;
      
    case 'hf':
      return <span>HF(%)</span>;
    case 'conductivity':
      return <span>conductivity</span>;
    case 'leakage':
      return <span>leakage</span>;
    case 'nh3':
      return (
        <span>
          NH<sub>3</sub>(ppm)
        </span>
      );
    default:
      return '';
  }
};

export const isNumber = (n) => {
  return !isNaN(parseFloat(n)) && !isNaN(n - 0);
};

export const convertSubTagString = (text) => {
  return text
    .split('')
    .map((text) => {
      return isNumber(text) ? `<sub>${text}</sub>` : text;
    })
    .join('');
};

export const batteryToText = (value) => {
  return Math.round(value) + '%';
};

export const batteryToImg = (value) => {
  if (value > 75) {
    return <TiBatteryCharge />;
  } else if (value > 50) {
    return <TiBatteryHigh />;
  } else if (value > 20) {
    return <TiBatteryMid />;
  } else {
    return <TiBatteryLow style={{ color: `#FF0000` }} />;
  }
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const classifyCriterionDataByModule = (criterion, moduleIdx) => {
  if (criterion.find((x) => x.module !== null && x.module.moduleIdx === moduleIdx) !== undefined) {
    return criterion.filter((x) => x.module !== null && x.module.moduleIdx === moduleIdx);
  } else {
    return criterion.filter((x) => x.module === null);
  }
};
